import { Component, Input  } from '@angular/core';

@Component({
  selector: 'app-sub-title',
  templateUrl: './sub-title.component.html',
  styleUrls: ['./sub-title.component.less']
})
export class SubTitleComponent{
  @Input() titleText: string = '';
  @Input() textAlign: string = 'left';
}
